import { useState, useEffect } from 'react';

const CONSENT_KEY = 'fornbo_analytics_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) {
      setVisible(true);
    } else if (stored === 'granted') {
      updateConsent('granted');
    }
  }, []);

  function updateConsent(state) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('consent', 'update', {
      'ad_storage': state,
      'ad_user_data': state,
      'ad_personalization': state,
      'analytics_storage': state,
    });
  }

  function accept() {
    updateConsent('granted');
    localStorage.setItem(CONSENT_KEY, 'granted');
    setVisible(false);
  }

  function decline() {
    localStorage.setItem(CONSENT_KEY, 'denied');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      background: '#2c2c2c', color: '#fff',
      padding: '1rem 1.5rem',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      gap: '1rem', flexWrap: 'wrap',
      zIndex: 9999, fontSize: '0.875rem',
    }}>
      <p style={{ margin: 0 }}>
        Vi använder Google Analytics för att förstå hur webbplatsen används.
        Ingen personlig information lagras.
      </p>
      <div style={{ display: 'flex', gap: '0.75rem', flexShrink: 0 }}>
        <button onClick={decline} style={{
          background: 'transparent', border: '1px solid #aaa',
          color: '#aaa', padding: '0.4rem 1rem', cursor: 'pointer', borderRadius: '4px',
        }}>Avböj</button>
        <button onClick={accept} style={{
          background: '#4a7c59', border: 'none',
          color: '#fff', padding: '0.4rem 1rem', cursor: 'pointer', borderRadius: '4px',
        }}>Acceptera</button>
      </div>
    </div>
  );
}
